'use client';

import { logger } from '@tuic/logger';
import { trackPageView, trackEvent } from '@tuic/tracking';
import { useEffect } from 'react';

import type { TelemetryInstruction } from '@modules/prism/versions/2025-07-01/utils/telemetry/types.api';
import type { FC } from 'react';

type Props = {
  telemetry: TelemetryInstruction[];
};

/**
 * Client component that fires immediate telemetry instructions
 */
export const FireImmediateTelemetry: FC<Props> = ({ telemetry }) => {
  useEffect(() => {
    if (telemetry.length === 0) {
      return;
    }

    try {
      for (const instruction of telemetry) {
        if (instruction.type === 'pageView') {
          trackPageView(instruction.data);
        } else if (instruction.type === 'event') {
          trackEvent({
            event_name: instruction.eventName,
            ...instruction.data,
          });
        }
      }
    } catch (error) {
      logger.error('Failed to fire immediate telemetry:', error);
    }
  }, [telemetry]);

  return null;
};
